import { render, staticRenderFns } from "./dc-vizlet.vue?vue&type=template&id=daa2d9bc&scoped=true&"
import script from "./dc-vizlet.vue?vue&type=script&lang=js&"
export * from "./dc-vizlet.vue?vue&type=script&lang=js&"
import style0 from "./dc-vizlet.vue?vue&type=style&index=0&id=daa2d9bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa2d9bc",
  null
  
)

export default component.exports